import moment from 'moment';
export default function ($rootScope, $scope, $stateParams, $http, $uibModal, $cookies, $window, $timeout, $uibModalInstance, $q, ngToast, CONFIG, items, entry, selectedItems, formControls, id, type, UtilitiesFactory) {
    'ngInject';
    let entries = items.data.items;
    let vm = this;
    let T = $scope.$root.T;
    let paginationResultsPerPage = CONFIG.paginationResultsPerPageModal;
    //let region = JSON.parse($cookies.get('region'));
    //let isAdmin = $rootScope.firebaseUser.isAdmin;

    vm.entries = entries;
    vm.entries_all = entries;
    vm.type = type;
    vm.entry = entry;
    vm.isProgressData = false;
    vm.selectedItems = selectedItems;
    vm.isMultipleSelection = false;
    vm.disabledSearch = false;
    vm.selection = [];
    vm.isProgress = false;
    vm.isDone = false;
    // Set selection counter to 0
    $scope.selCounter = 0;
    vm.witdh = '';
    vm.page = 1;
    vm.pagesTotal = Math.floor(items.data.total / paginationResultsPerPage);
    vm.paginationRange = UtilitiesFactory.paginationRange(vm.page, CONFIG.paginationLinksOffset, vm.pagesTotal.pagesTotal);

    console.log('appLinkEntriesModalCtrl()', vm.entries, vm.entry, vm.selectedItems);


    moment.locale('de');

    /***
     * Init
     */
    let init = () => {
        if (Array.isArray(vm.selectedItems)) {
                _.forEach(vm.selectedItems, (item) => {
                    vm.selection.push(item);
                });
        } else if (!!vm.selectedItems) {
            vm.selection.push(
                {
                    sys: {
                        type: 'Link',
                        linkType: 'Asset',
                        id: vm.selectedItems.id
                    }
                });
        }

        console.log(vm.selection, vm.selectedItems);
    };


    let parseMoment = () => {
        console.warn(vm.entries);
        _.forEach(vm.entries, (item) => {
            item.sys.createdAt = moment(item.sys.createdAt).format("DD. MMMM YYYY");
        });

    };
    /***
     * Create data for POST for Article
     * @returns {{}}
     */
    let dataToPostArticle = () => {
        let result = {};


        formControls.forEach(control => {
            let id = control.id;

            result[id] = vm.data[id];

            /**changed
             * Cause change of model
             */
            if (!!!result['region']) {
                let _region = JSON.parse($cookies.get('region'));
                let region = {
                    en: {
                        sys: {
                            'id': _region.sys.id,
                            'type': 'Link',
                            'linkType': 'Entry'
                        }
                    }
                };

                result['region'] = region;
            }

            if (id === vm.entry) {
                // Images
                if (
                    control.type === 'Array' &&
                    control.items.type === 'Link' &&
                    control.items.linkType === 'Asset' ) {
                    result[id] = _.map(vm.selectedItems, value => ({
                        sys: {
                            type: 'Link',
                            linkType: 'Asset',
                            id: value.sys.id
                        }
                    }));

                    if (vm.data.hasOwnProperty('images')) {
                        result[id] = [];
                        for (let image of vm.data.images.en) {
                            result[id].push(image);
                        }
                    }

                    result[id] = {
                        en: result[id]
                    };
                }

                // Articles and Specials
                if (control.type === 'Array' && control.items.type === 'Link' && control.items.linkType === 'Entry') {
                    if (!!!result[id]) {
                        result[id] = {};
                    }
                    result[id].hasOwnProperty('en') ? "nope" : result[id].en = {};

                    const existingArticles = _.map(result[id].en, article => ({
                        sys: {
                            type: 'Link',
                            linkType: 'Entry',
                            id: article.sys.id
                        }
                    }));

                    console.log(vm.selectedItems)
                    const newArticles = _.map(vm.selectedItems, item => ({
                        sys: {
                            type: 'Link',
                            linkType: 'Entry',
                            id: item.sys.id
                        }
                    }));

                    result[id] = {
                        en: [...newArticles] //...existingArticles
                    };
                }

                // NavigationItem
                if (control.type === 'Link' && control.linkType === 'Entry') {
                    result[id] = _.map(vm.selectedItems, id => {
                        result[id] = {
                            sys: {
                                type: 'Link',
                                linkType: 'Entry',
                                id: result[id]
                            }
                        };
                    });

                    result[id] = {
                        en: result[id]
                    };
                }
            }
        });


        console.log('result', result);

        return result;
    };


    /***
     * Create data for POST for Page
     * @returns {{}}
     */
    let dataToPostPage = () => {
        let result = {};

        formControls.forEach(control => {
            let id = control.id;
            result[id] = vm.data[id];

            if (id === 'backgroundImage') {
                result[id] = {
                    sys: {
                        type: 'Link',
                        linkType: 'Asset',
                        id: vm.selection[0].sys.id
                    }
                };

                result[id] = {
                    en: result[id]
                };
            }
        });

        console.log('result', result);

        return result;
    };


    /***
     * Choose the selection-mode (single or multiple)
     */
    let checkIsMultipleSelection = () => {
        formControls.forEach(control => {
            let id = control.id;

            if (control.type === 'Link' && control.linkType === 'Asset' && vm.entry === id) {
                vm.isMultipleSelection = "'single'";
            }

            if (control.type === 'Link' && control.linkType === 'Entry' && vm.entry === id) {
                vm.isMultipleSelection = "'single'";
            }

            if (control.type === 'Array' && control.items.type === 'Link' && control.items.linkType === 'Entry' && vm.entry === id) {
                vm.isMultipleSelection = "'multiple-additive'";
            }

            if (type === 'background' || type === 'file') {
                vm.isMultipleSelection = "'single'";
            }
        });

        console.log(vm.isMultipleSelection);
    };


    /***
     * Load More objects
     */
    vm.changePage = (page) => {
        //vm.search = '';
        vm.isProgressData = true;
        vm.entries = [];
        let endpoint = '', endpoint_2 = '';

        if (entry === 'images') {
            if (!!vm.search) {
                endpoint = `assets?mimetype_group=image&query=${vm.search}&sys.type[ne]=${(new Date()).valueOf()}`;
            } else {
                endpoint = `assets?mimetype_group=image&sys.type[ne]=${(new Date()).valueOf()}`;
            }
            if (vm.witdh !== '') {
                endpoint += `&query=${vm.witdh}`;
            }
        } else {
            if (!!vm.search) {
                endpoint = `entries?content_type=article&fields.title=${vm.search}&order=-sys.createdAt&sys.type[ne]=${(new Date()).valueOf()}`;
                endpoint_2 = `entries?content_type=article&fields.title[ne]=${vm.search}&query=${vm.search}&order=-sys.createdAt&sys.type[ne]=${(new Date()).valueOf()}`;
                endpoint_2 += `&skip=${ paginationResultsPerPage * (page - 1) }&limit=${ paginationResultsPerPage }`;
            } else {
                endpoint = `entries?content_type=article&order=-sys.createdAt&sys.type[ne]=${(new Date()).valueOf()}`;
            }
        }
        endpoint += `&skip=${ paginationResultsPerPage * (page - 1) }&limit=${ paginationResultsPerPage }`;

        console.log('page', page);

        $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint}`).then((data) => {
            vm.page = page;
            vm.entries = data.data.items;
            vm.pagesTotal = Math.floor(data.data.total / paginationResultsPerPage);
            vm.paginationRange = UtilitiesFactory.paginationRange(vm.page, CONFIG.paginationLinksOffset, vm.pagesTotal);

            parseMoment();

            if (entry !== 'images' && !!vm.search) {
                $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint_2}`).then((data) => {
                    let _entries = data.data.items;
                    (vm.entries.length > 0) ? vm.entries = vm.entries.concat(_entries) : vm.entries = _entries;

                    vm.pagesTotal = Math.floor(data.data.total / paginationResultsPerPage);
                    vm.paginationRange = UtilitiesFactory.paginationRange(vm.page, CONFIG.paginationLinksOffset, vm.pagesTotal);
                    vm.isProgressData = false;
                    vm.disabledSearch = false;

                    parseMoment();
                });
            } else {
                vm.isProgressData = false;
                vm.disabledSearch = false;
            }
        }, (e) => {
            $rootScope.raven.captureException(e);
            $rootScope.raven.showReportDialog();
        });
    };

    /***
     * Post the entries selected
     */
    vm.insertEntries = () => {
        vm.selectedItems =  vm.selection;
        console.log(vm.selectedItems)
        if (vm.entry !== 'images') {
            vm.isProgress = true;
            let sys = null;
            $http.get(`${CONFIG.cmApiUrl}entries/${id}?sys.type[ne]=${(new Date()).valueOf()}`).then(data => {
                sys = data.data.sys;

                let config = {
                    errorMessage: `${T.HTTP_PUT_ERROR_NOTIFICATION}`,
                    headers: {
                        'X-Contentful-Version': sys.version
                    }
                };

                vm.data = data.data.fields;
                console.log(vm.data);
                $q.all(dataToPostArticle()).then(data => {
                    return $http.put(`${CONFIG.cmApiUrl}entries/${id}`, {fields: data}, config).then(data => {
                        sys = data.data.sys;

                        let config = {
                            successMessage: `${T.HTTP_PUT_SUCCESS_NOTIFICATION}`,
                            errorMessage: `${T.HTTP_PUT_ERROR_NOTIFICATION}`,
                            headers: {
                                'X-Contentful-Version': sys.version
                            }
                        };

                        return $http.put(`${CONFIG.cmApiUrl}entries/${id}/published`, null, config).then(res => {
                            ngToast.create({
                                className: 'toast-success',
                                content: `${T.ARTICLE} ${T.HTTP_POST_SUCCESS_NOTIFICATION}`,
                                timeout: 5000
                            });

                            vm.isProgress = false;
                            let articles = data.data.fields.articles.en;
                            $uibModalInstance.close({articles});
                        }, (e) => {
                            $rootScope.raven.captureException(e);
                            $rootScope.raven.showReportDialog();
                        });
                    });
                }).finally(() => {
                    vm.isProgress = false;
                });
            });
        } else {
            $uibModalInstance.close({selectedItems: vm.selectedItems});
        }
    };


    /***
     * Get Images for the link
     */
    vm.getImages = () => {
        let image = vm.selection;
        $uibModalInstance.close({image});
    };

    /***
     * Insert/Update background of selected page
     */
    vm.insertBackground = () => {
        let sys;
        let config = {
            errorMessage: T.HTTP_GET_ERROR_NOTIFICATION
        };

        if (!vm.isDone) {
            vm.isDone = true;
            vm.isProgress = true;
        $http.get(`${CONFIG.cmApiUrl}entries/${id}?sys.type[ne]=${(new Date()).valueOf()}`, config).then(data => {
            sys = data.data.sys;

            let config = {
                errorMessage: `${T.HTTP_PUT_ERROR_NOTIFICATION}`,
                headers: {
                    'X-Contentful-Version': sys.version
                }
            };

            vm.data = data.data.fields;
            $q.all(dataToPostPage()).then(data => {
                let dataToPost = data;

                return $http.put(`${CONFIG.cmApiUrl}entries/${id}`, {fields: dataToPost}, config).then(data => {
                    sys = data.data.sys;

                    let config = {
                        successMessage: `${T.HTTP_PUT_SUCCESS_NOTIFICATION}`,
                        errorMessage: `${T.HTTP_PUT_ERROR_NOTIFICATION}`,
                        headers: {
                            'X-Contentful-Version': sys.version
                        }
                    };

                    return $http.put(`${CONFIG.cmApiUrl}entries/${id}/published`, null, config).then(res => {
                        vm.isDone = false;
                        $uibModalInstance.close({id});
                    });
                }, (e) => {
                    vm.isDone = false;
                    $rootScope.raven.captureException(e);
                    $rootScope.raven.showReportDialog();
                });
            }).finally(() => {
                vm.isDone = false;
                vm.isProgress = false;
            });
        });
        }
    };

    /***
     * Add/Remove assets to array
     * @param item
     */
    vm.toggleSelectionAssets = (item) => {
        if (type === 'background' || type === 'file') {
            vm.selection = [];
            vm.selection.push(item);
        } else {
            console.log(vm.selection, item)
            let idx =  _.filter(vm.selection, (selection) => { return selection.sys.id === item.sys.id}); //vm.selection.indexOf(item);
            if (idx.length > 0) {
                console.log('Remove it', idx, item);
                vm.selection = _.filter(vm.selection, (selection) => { return selection.sys.id !== item.sys.id});
            } else {
                console.log('Add it', item, item.sys.id);
                let itm = {
                    sys: {
                        id: item.sys.id,
                        type: item.sys.type,
                        linkType: item.sys.linkType
                    }
                };
                vm.selection.push(itm);
            }
        }

        console.log(vm.selection);
    };


    /***
     * Checked if any entry has been already added to
     * @param item
     * @returns {boolean}
     */
    vm.checked = (item) => {
        let flag = false;
        let idx =  _.filter(vm.selection, (selection) => { return selection.sys.id === item.sys.id});

        if (idx.length > 0) {
            flag = true;
        }

        return flag;
    };


    vm.checkIfAssetCheched = (asset) => {
        let array = _.filter(vm.selection, (selection) => { return  selection.sys.id === asset.sys.id });
        return array.length > 0;
    };

    /***
     * Toggle feat for entry
     * @param id
     */
     vm.toggleSelection = (id) => {
         let idx =  _.filter(vm.selection, (selection) => { return selection.sys.id === id});
         console.log('idx: ', idx);
         if (idx.length > 0) {
             console.log('Remove it', idx);
             vm.selection = _.filter(vm.selection, (selection) => { return selection.sys.id !== id});
         } else {
             console.log('Add it');
             let itm = {
                 sys: {
                     id: id,
                     type: 'Link',
                     linkType: 'Entry'
                 }
             };
             vm.selection.push(itm);
         }

         console.log(vm.selection);
        $scope.selCounter = vm.selection.length;
    };

    /***
     * Search Engine
     * @param word
     * @param keyCode
     */
    vm.changed = (word, keyCode) => {
        let endpoint = '', endpoint_2 = '';
        if (entry === 'images') {
            endpoint = `assets?mimetype_group=image&query=${word}&sys.type[ne]=${(new Date()).valueOf()}`;
            if (vm.witdh !== '') {
                endpoint += `&query=${vm.witdh}`;
            }
        } else {
            endpoint = `entries?content_type=article&fields.title=${word}&order=-sys.createdAt&sys.type[ne]=${(new Date()).valueOf()}`;
            endpoint_2 = `entries?content_type=article&fields.title[ne]=${word}&query=${word}&order=-sys.createdAt&sys.type[ne]=${(new Date()).valueOf()}`;
        }

        if (keyCode === 13 || word === '') {
            //vm.entries = [];
            vm.disabledSearch = true;
            vm.isProgressData = true;
            $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint}`).then((data) => {
                vm.page = 1;
                vm.entries = data.data.items;
                vm.pagesTotal = Math.floor(data.data.total / paginationResultsPerPage);
                vm.paginationRange = UtilitiesFactory.paginationRange(vm.page, CONFIG.paginationLinksOffset, vm.pagesTotal);

                parseMoment();

                if (entry !== 'images') {
                    $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint_2}`).then((data) => {
                        let _entries = data.data.items;
                        (vm.entries.length > 0) ? vm.entries = vm.entries.concat(_entries) : vm.entries = _entries;
                        vm.pagesTotal = Math.floor(data.data.total / paginationResultsPerPage);
                        vm.paginationRange = UtilitiesFactory.paginationRange(vm.page, CONFIG.paginationLinksOffset, vm.pagesTotal);
                        vm.isProgressData = false;
                        vm.disabledSearch = false;

                        parseMoment();
                    });
                } else {
                    vm.isProgressData = false;
                    vm.disabledSearch = false;
                }
                $timeout(function() {
                    let search_element = $window.document.getElementById("search");
                    search_element.focus();
                });

            });
        }
    };


    /***
     * Submit
     */
    vm.submit = () => {
        console.log(vm.type);
        if (vm.type === 'background') {
            vm.insertBackground();
        } else if (vm.type === 'file') {
            vm.getImages();
        } else {
            vm.insertEntries()
        }
    };

    /***
     * Sort
     */
    $scope.orderProperty = '';
    $scope.sortProperty = function(orderby) {
        console.log('orderby: ', orderby);

        if (orderby === 'desc') {
            $scope.orderProperty = 'reverse'
        } else if (orderby === 'asc'){
            $scope.orderProperty = ''
        }
    };

    vm.findImages = (width, keyCode) => {
        vm.witdh = width;
        if (keyCode === 13 || width === '') {
            let endpoint = `assets?query=${width}&mimetype_group=image&sys.type[ne]=${(new Date()).valueOf()}`;
            $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint}`).then((data) => {
                //console.warn(data.data);
                vm.entries = data.data.items;
                vm.page = 1;
                vm.entries = data.data.items;
                vm.pagesTotal = Math.floor(data.data.total / paginationResultsPerPage);
                vm.paginationRange = UtilitiesFactory.paginationRange(vm.page, CONFIG.paginationLinksOffset, vm.pagesTotal);
            });
        }
    }

    init();
    checkIsMultipleSelection();
    parseMoment();
}



// WEBPACK FOOTER //
// ./src/app/views/app.modal/appLinkEntriesModalCtrl.js